$(document).ready(function(){
    $(".accordion_header").click(function(){
        $(this).next(".accordion_content").slideToggle();
        $(this).find("svg").toggleClass("rotate");
    });
    $(window).scroll(function(){
        if ($(this).scrollTop() >= 500) {
            $('.scroll_top_btn').fadeIn();
        } else {
            $('.scroll_top_btn').fadeOut();
        }
    });
    $('.scroll_top_btn').click(function(){
        $('html, body').animate({ scrollTop: 0 }, 600);
    });
});
